import {
  SidebarContent,
  SidebarGroup,
  SidebarSeparator,
} from '@/components/ui/sidebar'
import { Input } from '@/components/ui/input'
import { Search } from 'lucide-react'
import { Settings2 } from 'lucide-react'
import { mockNotification } from '../notification/mock-notification'
import { ContestCard } from '@/components/common'

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { ChipSelect } from '@/components/main/contests/chip-select'
import { CategoryChip } from '@/hooks/api/use-categories'

export function AppSidebarContent() {
  const handleFilterChange = (activeChips: CategoryChip[]) => {
    // Handle filter changes here
    console.log('Active chips:', activeChips)
  }

  return (
    <>
      <SidebarSeparator className="mx-0 h-[0.5px] bg-black" />
      <SidebarContent>
        <SidebarGroup className="py-6">
          <Popover>
            <div className="relative">
              <Search className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-400" />
              <Input
                placeholder="ค้นหางานแข่ง"
                className="relative flex justify-between rounded-full py-2 pl-10 pr-4 font-line text-xs font-normal text-zinc-400 shadow-md"
              />
              <PopoverTrigger className="absolute right-4 top-1/2 -translate-y-1/2">
                <Settings2 className="h-4 w-4 text-zinc-400" />
              </PopoverTrigger>
            </div>
            <PopoverContent
              align="end"
              className="ml-4 mt-4 inline-flex min-w-80 flex-initial flex-col justify-center gap-3 rounded-md bg-white py-3 font-line text-sm font-normal text-zinc-900"
            >
              <div className="gap-2 py-1">
                <ChipSelect onFilterChange={handleFilterChange} />
              </div>
            </PopoverContent>
          </Popover>
          <div className="flex flex-col gap-4 px-2 py-6">
            {mockNotification.map((item) => (
              // @ts-expect-error - Fix this later
              <ContestCard key={item.id} contest={item} />
            ))}
          </div>
        </SidebarGroup>
      </SidebarContent>
    </>
  )
}
